import { Box, Tabs, Tab, alpha } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface StatusTabsProps {
  statusFilter: string;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  showResponseTab: boolean;
}

export const StatusTabs = ({ statusFilter, onChange, showResponseTab }: StatusTabsProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: 2,
        borderBottom: `1px solid ${theme.palette.divider}`,
        bgcolor: alpha(theme.palette.primary.main, 0.02)
      }}
    >
      <Tabs
        value={statusFilter}
        onChange={onChange}
        sx={{
          minHeight: 48,
          "& .MuiTabs-flexContainer": {
            gap: 0
          },
          "& .MuiTab-root": {
            fontWeight: 600,
            fontSize: "0.875rem",
            textTransform: "none",
            minHeight: 48,
            px: 3,
            color: "text.secondary",
            "&.Mui-selected": {
              color: "primary.main"
            }
          },
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: "3px 3px 0 0"
          }
        }}
      >
        <Tab label="Closed Orders" value="Closed" />
        <Tab label="Received Orders" value="Received" />
        <Tab label="Missed Contacts - Closed" value="ClosedMissed" />
        <Tab label="Missed Contacts - Received" value="ReceivedMissed" />
        {showResponseTab && <Tab label="Client Responses" value="Response" />}
      </Tabs>
    </Box>
  );
};
